import React, { useState } from 'react';
import { useParams } from 'react-router';
import { BasePage } from '../../components/base-page';
import { TaskDetailContent } from '../../components/task-detail-content';

export function TaskDetailPage() {
  const { taskId } = useParams();
  const [title, setTitle] = useState('');

  return (
    <BasePage title={`Úloha${title ? ` - ${title}` : ''}`}>
      {taskId && <TaskDetailContent taskId={taskId} onTitleChange={setTitle} />}
    </BasePage>
  );
}
